import { useFiltersContext } from '../../../contexts';

export const useFilterCount = () => {
  const { types } = useFiltersContext();
  let filterCount = 0;

  if (types.length) {
    filterCount += types.length;
  }

  return filterCount;
};
